import { QueryParameters } from '../../../../core/entities/query-parameters.class';

export class AdvancedFilterRequest {
  queryParameters: QueryParameters;
  name: string;
  id: number;
}
